import { Badge, Button, Card, Input, Spacer, Textarea, Tooltip } from '@nextui-org/react';
import {
  ArrowRight,
  Award,
  Check,
  ChevronDown,
  ChevronUp,
  Clipboard,
  Edit,
  Edit2,
  Flag,
  Link as LinkIcon,
  MessageSquare,
  User,
} from 'react-feather';
import { toast } from 'react-toastify';

import { useTheme } from 'next-themes';
import Link from 'next/link';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Tag } from '../generated/graphql';
import { HadithModalData } from '../pages/chapter/[bookId]/[sectionId]/[chapterNumber]';
import { baseURL, tryJSONParse } from '../utils/utils';
import Accordion from './Accordion';
import ChainsSection from './ChainsSection';
import CommentSection from './CommentSection';
import GradingSection from './GradingSection';
import TextWithHonorifics from './TextWithHonorifics';

export const toastStyle = (dark = false) => ({
  borderRadius: '15px',
  WebkitBorderRadius: '15px',
  MozBorderRadius: '15px',
  color: dark ? '#fff' : '#000',
  backgroundColor: dark ? '#000000' : '#fff',
});

export function HadithCard({
  english,
  arabic,
  number,
  gradings,
  chains,
  bookId,
  comments,
  sectionNumber,
  chapterNumber,
  topGap,
  setReportHadithModalVisible,
  setNarratorInfoModalVisible,
  setReportHadithModalData,
  setNarratorId,
  startingIndex,
  tags,
  user,
  expandAllGradings,
  expandAllComments,
  showEditButton = false,
  showEnglishText = false,
  sourceTextId,
  translationTextId,
  type,
  actionsExpanded,
  updateHadithMutation,
  viewCount,
}: {
  tags?: Tag[];
  english: String;
  arabic: String;
  number: String | number;
  gradings: any;
  comments: any;
  chains: any;
  startingIndex?: number;
  bookId: String | number;
  sectionNumber: String;
  chapterNumber: String;
  topGap: boolean;
  setReportHadithModalVisible: any;
  setNarratorInfoModalVisible: any;
  setReportHadithModalData: Dispatch<SetStateAction<HadithModalData>>;
  setNarratorId: any;
  user?: any;
  expandAllGradings?: boolean;
  expandAllComments?: boolean;
  showEditButton: boolean;
  showEnglishText?: boolean;
  sourceTextId?: string;
  translationTextId?: string;
  type?: string;
  actionsExpanded?: boolean;
  updateHadithMutation: any;
  viewCount?: number;
}) {
  const [showChain, setShowChain] = useState(false);
  const [showGrading, setShowGrading] = useState<boolean | null | undefined>(null);
  const [showComment, setShowComment] = useState<boolean>(false);
  const [editing, setEditing] = useState(false);
  const [showEnglish, setShowEnglish] = useState<any>(null);
  const [englishTextArea, setEnglishTextArea] = useState<any>(english);
  const [sourceTextArea, setSourceTextArea] = useState<any>(arabic);
  const [settingStartIndex, setSettingStartIndex] = useState(false);
  const [newStartingIndex, setNewStartingIndex] = useState(startingIndex);
  const [showActionButtons, setShowActionButtons] = useState(
    actionsExpanded != undefined ? actionsExpanded : type != 'REGULAR'
  );
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';

  useEffect(() => {
    setShowGrading(expandAllGradings);
    setShowEnglish(showEnglishText);
    setShowComment(expandAllComments as boolean);
  }, [expandAllGradings, showEnglishText, expandAllComments]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const el = window.document.getElementById('translation-textarea');
      const el2 = window.document.getElementById('source-textarea');
      // @ts-ignore
      if (el) el.value = english;
      // @ts-ignore
      if (el2) el2.value = arabic;
    }
  }, [english, arabic, editing]);

  if (showEnglishText == null) return null;

  const isHadithBook = type != 'REGULAR';
  const hasComments = comments && comments.length > 0;
  const textType = isHadithBook ? 'Hadith' : 'Passage';

  const hadithCopiedElement = (
    <div>
      <Clipboard className="inline mr-2" />
      {textType} copied to clipboard
    </div>
  );

  const hadithLinkElement = (
    <div>
      <LinkIcon className="inline mr-2" />
      {textType} link copied to clipboard
    </div>
  );

  console.log('showActionButtons', gradings?.trim() == ',');

  function renderActionButtons() {
    return (
      <div className="flex flex-row justify-between w-full">
        <Button.Group flat color="default">
          {chains && tryJSONParse(chains) && JSON.parse(chains)?.length >= 1 && (
            <Tooltip content={`${showChain ? 'Hide' : 'Show'} chain`}>
              <Button
                aria-label="Show chain"
                className="hover:-translate-y-1 ease-in-out"
                onClick={() => {
                  setShowChain(!showChain);
                }}
              >
                <User />
              </Button>
            </Tooltip>
          )}
          {gradings && gradings.length > 1 && gradings?.trim() != ',' && (
            <Tooltip
              content={`${showGrading || (showGrading == null && expandAllGradings) ? 'Hide' : 'Show'} gradings`}
            >
              <Button
                aria-label="Show gradings"
                className="hover:-translate-y-1 ease-in-out"
                onClick={() => {
                  setShowGrading(!showGrading);
                }}
              >
                <Award />
              </Button>
            </Tooltip>
          )}
          {comments && comments.length > 0 && (
            <Tooltip
              content={`${showComment || (showComment == null && expandAllComments) ? 'Hide' : 'Show'} comments`}
            >
              <Button
                aria-label="Show comments"
                className="hover:-translate-y-1 ease-in-out"
                onClick={() => {
                  setShowComment(!showComment);
                }}
              >
                <MessageSquare />
              </Button>
            </Tooltip>
          )}
          {/* <Tags tags={tags} /> */}
        </Button.Group>
        <Button.Group flat>
          {editing && (
            <>
              <Button
                className="hover:-translate-y-1 ease-in-out"
                color="success"
                onClick={() => {
                  setEditing(!editing);
                }}
              >
                Cancel
              </Button>
              <Button
                className="hover:-translate-y-1 ease-in-out"
                color="success"
                onClick={() => {
                  setEditing(!editing);

                  if (arabic !== sourceTextArea)
                    updateHadithMutation({
                      variables: {
                        hadithId: String(sourceTextId),
                        content: sourceTextArea,
                        ...(newStartingIndex != null &&
                          newStartingIndex !== startingIndex && {
                            startingIndex: String(newStartingIndex),
                          }),
                      },
                    })
                      .then(({ errors, data }: { errors: any; data: any }) => {
                        if (errors) toast.error(`Error updating ${textType}: ${errors.message}`);
                        else toast.success(`Updated ${textType} - change may reflect next deploy`);
                      })
                      .catch((error: any) => toast.error(`Error updating ${textType}: ${error}`));

                  if ((english !== englishTextArea || newStartingIndex != startingIndex) && englishTextArea != null)
                    updateHadithMutation({
                      variables: {
                        hadithId: String(translationTextId),
                        ...(english !== englishTextArea && { content: englishTextArea }),
                        ...(newStartingIndex != null &&
                          newStartingIndex !== startingIndex && {
                            startingIndex: String(newStartingIndex),
                          }),
                      },
                    })
                      .then(({ errors, data }: { errors: any; data: any }) => {
                        if (errors) toast.error(`Error updating ${textType}: ${errors.message}`);
                        else toast.success(`Updated ${textType} - change may reflect next deploy`);
                      })
                      .catch((error: any) => toast.error(`Error updating ${textType}: ${error}`));
                }}
              >
                Save
              </Button>
            </>
          )}
          {showEditButton && (
            <>
              <Tooltip content={`Edit ${textType}`}>
                <Button
                  aria-label={`Copy ${textType}`}
                  className="hover:-translate-y-1 ease-in-out"
                  onClick={() => {
                    setEditing(!editing);
                  }}
                >
                  <Edit />
                </Button>
              </Tooltip>
              <Tooltip content={`Go to hadith page`}>
                <Link href={`/hadith/${bookId}/${sectionNumber}/${chapterNumber}/${number}`}>
                  <Button aria-label={`Copy ${textType}`} className="hover:-translate-y-1 ease-in-out">
                    <ArrowRight />
                  </Button>
                </Link>
              </Tooltip>
            </>
          )}
          <Tooltip content={`Copy ${textType}`}>
            <Button
              aria-label={`Copy ${textType}`}
              className="hover:-translate-y-1 ease-in-out"
              onClick={() => {
                navigator.clipboard.writeText(
                  `${arabic}\n\n${english}\n\n- https://thaqalayn.net/hadith/${bookId}/${sectionNumber}/${chapterNumber}/${number}`
                );
                toast(hadithCopiedElement, {
                  style: toastStyle(resolvedTheme === 'dark'),
                  hideProgressBar: true,
                });
              }}
            >
              <Clipboard />
            </Button>
          </Tooltip>
          <Tooltip content={`Get ${textType} link`}>
            <Button
              aria-label={`Get ${textType} link`}
              className="hover:-translate-y-1 ease-in-out"
              onClick={() => {
                navigator.clipboard.writeText(
                  `${baseURL()}/hadith/${bookId}/${sectionNumber}/${chapterNumber}/${number}`
                );
                toast(hadithLinkElement, {
                  style: toastStyle(resolvedTheme === 'dark'),
                  hideProgressBar: true,
                });
              }}
            >
              <LinkIcon />
            </Button>
          </Tooltip>
          <Tooltip content={`Report ${textType}`}>
            <Button
              aria-label={`Report ${textType}`}
              className="hover:-translate-y-1 ease-in-out"
              onClick={() => {
                setReportHadithModalVisible(true);
                setReportHadithModalData({
                  hadithNumber: String(number),
                  chapterName: String(chapterNumber),
                  visible: true,
                });
              }}
            >
              <Flag />
            </Button>
          </Tooltip>
          {!isHadithBook && (
            <Button
              light
              color={'warning'}
              ripple={false}
              onClick={() => {
                setShowActionButtons(!showActionButtons);
                setShowComment(false);
                setShowGrading(false);
                setShowChain(false);
              }}
            >
              <ChevronUp size={25} />
            </Button>
          )}
        </Button.Group>
      </div>
    );
  }

  const topMargin = topGap ? (isHadithBook ? 'mt-20' : 'mt-6') : '';

  return (
    <Card className={`lg:w-3/5 md:w-3/4 w-22/23 ${topMargin} transition-height duration-500 ease-in-out`} role="group">
      <Card.Header>
        <h1 className="pt-5 pl-5 text-xl font-bold">
          {isHadithBook ? 'Hadith' : 'Passage'} #{number}
        </h1>
      </Card.Header>
      <Card.Body className={`${isHadithBook ? 'md:p-10' : 'md:px-10 md:py-2'} p-4`}>
        {editing ? (
          <Textarea
            fullWidth
            bordered={isDark}
            className="font-naksh text-right tracking-arabic"
            dir="rtl"
            id="source-textarea"
            maxRows={8}
            minRows={6}
            style={{
              fontSize: '1.5rem',
            }}
            onChange={(e) => {
              setSourceTextArea(e.target.value);
              setEditing(true);
            }}
          />
        ) : (
          <div className={!showEnglishText ? 'pb-4' : ''}>
            <p className="font-naksh text-2xl text-right tracking-arabic" dir="rtl">
              {arabic}
            </p>
          </div>
        )}

        <Accordion duration={0.5} initial={false} open={showEnglishText}>
          <hr className="h-0.5 my-8 bg-gray-200 border-0 dark:bg-gray-500" />
          {editing ? (
            <>
              <Textarea
                fullWidth
                bordered={isDark}
                className="font-sans"
                id="translation-textarea"
                minRows={6}
                rows={english.length / 200}
                style={{
                  fontSize: '1.125rem',
                }}
                onChange={(e) => {
                  setEnglishTextArea(e.target.value);
                  setEditing(true);
                }}
                onSelect={(e) => {
                  // get the current caret position
                  if (!settingStartIndex) return;
                  const caretPosition = e.currentTarget.selectionStart;
                  if (typeof caretPosition === 'number') setNewStartingIndex(caretPosition as number);
                }}
              />
              <Spacer y={1} />
              <div className="flex flex-row">
                <Input
                  readOnly
                  bordered={isDark}
                  className="!w-32"
                  contentRightStyling={false}
                  label="Start Index"
                  status={settingStartIndex ? 'primary' : 'default'}
                  value={newStartingIndex}
                />
                <Button
                  flat
                  className="p-0 mt-auto !w-12"
                  color="primary"
                  icon={settingStartIndex ? <Check className="" /> : <Edit2 className="" />}
                  style={{ width: '3rem' }}
                  onClick={() => {
                    setSettingStartIndex(!settingStartIndex);
                  }}
                />
              </div>
            </>
          ) : (
            <div className={!isHadithBook ? 'pb-4' : ''}>
              <p className="text-lg font-sans">
                <TextWithHonorifics startingIndex={startingIndex} text={english} />
              </p>
            </div>
          )}
        </Accordion>
      </Card.Body>
      {!isHadithBook && !showActionButtons && (
        <div className="ml-auto absolute bottom-0 right-0 w-20">
          <Button
            auto
            light
            className="w-full !p-0"
            ripple={false}
            onClick={() => setShowActionButtons(!showActionButtons)}
          >
            {hasComments ? (
              <Badge color="warning" content={hasComments ? ' ' : ''} size="xs">
                <ChevronDown size={25} />
              </Badge>
            ) : (
              <ChevronDown size={25} />
            )}
          </Button>
        </div>
      )}
      <Accordion duration={0.5} initial={false} open={showActionButtons}>
        {renderActionButtons()}
      </Accordion>
      {chains && chains.length > 0 && (
        <ChainsSection
          chains={chains}
          setNarratorId={setNarratorId}
          setNarratorInfoModalVisible={setNarratorInfoModalVisible}
          showChain={showChain}
        />
      )}
      {gradings && gradings.length > 0 && gradings?.trim() != ',' && (
        <GradingSection gradings={gradings} showGrading={showGrading || (showGrading == null && expandAllGradings)} />
      )}
      <CommentSection
        comments={comments}
        showComment={showComment || ((showComment == null && expandAllComments) as boolean)}
      />
    </Card>
  );
}
